<template>
  <div class="reader-select">
    <div
      class="trigger"
      @click.stop="onClickTrigger"
    >
      {{label}}
      <iconfont
        class="tri"
        :class="{active: triggerOn}"
        name="#iconxialaxiaosanjiao"
        font-size="8px"
        style="color: #9692A9;"
      ></iconfont>
    </div>
    <div
      class="options"
      v-if="triggerOn"
      @click.stop
    >
      <div class="tabs">
        <div
          class="tab all"
          :class="{active: '' === activeTab}"
          @click="onClickTab({value: ''})"
        >全部</div>
        <div
          class="tab"
          :class="{active: (tab.value || '').split(',').indexOf(activeTab) > -1}"
          v-for="(tab, i) in tabs"
          :key="i"
          @click="onClickTab(tab)"
        >{{tab.name}}</div>
      </div>
      <div class="items-wrapper">
        <div class="items">
          <!-- <Reader></Reader> -->
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import readerBus from './readerBus.js';
export default {
  props: {
    value: {
      default () {
        return '';
      }
    },
    options: {
      default () {
        return [];
      }
    }
    // triggerOn: {
    //   default: false
    // }
  },
  components: {
    iconfont: () => import('@/platformCode/iconfont')
  },
  data () {
    return {
      label: '',
      triggerOn: false,
      tabs: [],
      activeTab: ''
    }
  },
  watch: {
    options () {
      this.updateLabel();
      this.updateTabs();
    },
    triggerOn () {
      this.updateTabs();
      this.activeTab = '';
      this.stopPreview();
    },
    activeTab () {
      this.stopPreview();
    }
  },
  created () {
    readerBus.$on('clickReader', this.onClickReader);
  },
  beforeDestroy () {
    readerBus.$off('clickReader', this.onClickReader);
  },
  mounted () {
    // this.$slots.default.some((item) => {
    //   let matched = item.data.attrs.value === this.value;
    //   if (matched) {
    //     this.label = item.data.attrs.label;
    //   }
    //   return matched
    // });
    $('body').on('click', this.onClickBody)
  },
  beforeDestroy () {
    $('body').off('click', this.onClickBody)
  },
  methods: {
    onClickTrigger () {
      this.$emit('triggerOn');
      this.triggerOn = !this.triggerOn;
    },
    onClickBody () {
      this.triggerOn = false;
    },
    updateLabel () {
      this.options.some((item) => {
        let matched = item.value === this.value;
        if (matched) {
          this.label = item.label;
        }
        return matched;
      });
    },
    onClickReader ({ value } = {}) {
      this.$emit('input', value);
      this.$nextTick(() => {
        this.updateLabel();
        this.triggerOn = false;
      })
    },
    updateTabs () {
      let cates = this.options.reduce((memo, { category } = {}) => {
        if (!category) {
          return memo;
        }
        let arr = [category];
        if (category.indexOf(',') > -1) {
          arr = category.split(',');
        }
        arr.forEach(v => {
          if (memo.indexOf(v) < 0) {
            memo.push(v);
          }
        })
        return memo;
      }, []) || [];
      //0: 男声  1：女声 2：童声 3:英文
      let names = ['男声', '女声', '童声', '英文', '中英混合'];
      cates = cates.sort((a, b) => a - b).map(v => {
        return {
          value: v,
          name: names[v]
        }
      });
      this.tabs = cates;
    },
    onClickTab ({ value } = {}) {
      this.activeTab = value;
      this.$nextTick(() => {
        this.$emit('onClickTab', {
          value
        });
      })
    },
    stopPreview () {
      $(this.$el).find('audio').each((i, el) => {
        el.pause();
        el.currentTime = 0;
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.reader-select {
  position: relative;
  display: inline-block;
}
.trigger {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 204px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  padding-left: 26px;
  padding-right: 26px;
  cursor: pointer;
  & > .tri {
    transition-duration: 0.3s;
  }
  & > .tri.active {
    transform: rotate(-180deg);
  }
}
.options {
  position: absolute;
  top: calc(100% + 6px);
  z-index: 1;
  background-color: #fff;
  width: 735px;
  height: 395px;
  background: #ffffff;
  border: 1px solid #d8dee9;
  box-shadow: 0px 2px 10px 0px rgba(99, 100, 131, 0.12);
  &:after {
    content: '';
    width: calc(100% - 8px);
    height: 20px;
    position: absolute;
    left: 0;
    bottom: 0;
    background-color: #fff;
  }
}
.items {
  display: flex;
  flex-wrap: wrap;
  padding-left: 8px;
  padding-top: 40px;
  padding-bottom: 25px;
}
.item {
  flex-shrink: 0;
}
.tabs {
  position: absolute;
  left: 0;
  top: 0;
  width: calc(100% - 8px);
  background-color: #fff;
  display: flex;
  padding-top: 20px;
  padding-bottom: 8px;
}
.tab {
  margin-left: 15px;
  cursor: pointer;
  &:first-of-type {
    margin-left: 20px;
  }
  &.active {
    font-size: 14px;
    color: #5778fb;
  }
}
.items-wrapper {
  height: 100%;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 6px;
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #fff;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #D8DEE9;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #bdbdbe;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/generateVoice/readerSelect.vue